import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemText, Typography, Paper, Button } from '@material-ui/core';
import { CSVLink } from 'react-csv';
import SimpleDialogDemo from '../../../Modals/SimpleDialog';
import ParticipantDetailContainer from '../ParticipantDetail/ParticipantDetailContainer';
import FormDialog from '../../../Modals/FormDialog';

const ParticipantesListResumen = ({
  participantes,
  modalidad,
  rama,
  categoria,
  eventSubEventsRegistry,
}) => {
  const filtrarParticipantes = () => {
    return participantes.filter(participante => {
      const esValido =
        participante.statusPago?.status === 'ok' && !participante.borrado;

      const coincideModalidad = modalidad ? participante.modalidad / 1 === +modalidad : true;
      const coincideRama = rama ? participante.rama === rama : true;
      const coincideCategoria = categoria ? participante.categoria / 1 === +categoria : true;

      return esValido && coincideModalidad && coincideRama && coincideCategoria;
    });
  };

  const participantesFiltrados = filtrarParticipantes().sort(
    (a, b) => a.numero / 1 - b.numero / 1
  );

  const generarNombreArchivo = () => {
    const partes = ['participantes-'];
    if (modalidad) partes.push(`modalidad:${eventSubEventsRegistry["modalidad_" + modalidad].descripcionModalidad || ''}`);
    if (rama) partes.push(`rama:${rama}`);
    if (categoria) partes.push(`categoria:${eventSubEventsRegistry["modalidad_" + modalidad].ramaCat["rama_" + rama].categorias["categoria_" + categoria].nombreCategoria}`);
    const fecha = new Date().toISOString();
    partes.push(fecha);
    return partes.join('_') + '.csv';
  };

  // Datos exportables al CSV
  const datosCSV = participantesFiltrados.map(p => {
    const modalidadInfo = eventSubEventsRegistry?.[`modalidad_${p.modalidad}`] || {};
    const categoriaInfo =
      modalidadInfo.ramaCat?.[`rama_${p.rama}`]?.categorias?.[`categoria_${p.categoria}`] || {};

    return {
      Número: p.numero,
      Nombres: p.nombres?.trim(),
      Apellidos: p.apellidos?.trim(),
      Modalidad: modalidadInfo.descripcionModalidad || '',
      Rama: p.rama,
      Categoría: categoriaInfo.nombreCategoria || '',
      Correo: p.correo || '',
      Teléfono: p.telefono || '',
      Talla: p.talladeplayera || '',
      FechaRegistro: p.fechaRegistro || '',
    };
  });

  // Headers opcionales para el CSV (puedes agregar/quitar fácilmente)
  const headers = [
    { label: 'Número', key: 'Número' },
    { label: 'Nombres', key: 'Nombres' },
    { label: 'Apellidos', key: 'Apellidos' },
    { label: 'Modalidad', key: 'Modalidad' },
    { label: 'Rama', key: 'Rama' },
    { label: 'Categoría', key: 'Categoría' },
    // { label: 'Correo', key: 'Correo' },
    // { label: 'Teléfono', key: 'Teléfono' },
    // { label: 'Talla', key: 'Talla' },
    // { label: 'Fecha de Registro', key: 'FechaRegistro' },
  ];

  return (
    <Paper style={{ padding: 16 }}>
      <Typography variant="h6">Lista de Participantes</Typography>

      <CSVLink
        data={datosCSV}
        headers={headers}
        filename={generarNombreArchivo()}
        style={{ textDecoration: 'none' }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ margin: '16px 0' }}
        >
          Descargar CSV
        </Button>
      </CSVLink>

      <List>
        {participantesFiltrados.map((p, index) => {
          const modalidadInfo = eventSubEventsRegistry?.[`modalidad_${p.modalidad}`] || {};
          const categoriaInfo =
            modalidadInfo.ramaCat?.[`rama_${p.rama}`]?.categorias?.[`categoria_${p.categoria}`] || {};

          return (
            <ListItem key={index} divider>
              <ListItemText
                primary={`${p.numero} - ${p.nombres} ${p.apellidos}`}
                secondary={`Modalidad: ${modalidadInfo.descripcionModalidad || ''} | Rama: ${p.rama} | Categoría: ${categoriaInfo.nombreCategoria || ''}`}
              />
              <FormDialog
                buttomLabel={"ver"}
                ShowIcon={false}
                ButtonStyle={null}
                maxWidthProp={"lg"}
                style={{
                  minHeight: "80vh",
                  maxHeight: "80vh",
                }}
                report={
                  <ParticipantDetailContainer
                    ParticipantDetail={p}
                    ParticipantDetailKey={p.key}
                  />
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

ParticipantesListResumen.propTypes = {
  participantes: PropTypes.arrayOf(PropTypes.object).isRequired,
  modalidad: PropTypes.string,
  rama: PropTypes.string,
  categoria: PropTypes.string,
  eventSubEventsRegistry: PropTypes.object.isRequired,
};

export default ParticipantesListResumen;
